export const OPEN_TERMS_MODAL = 'OPEN_TERMS_MODAL';
export const CLOSE_TERMS_MODAL = 'CLOSE_TERMS_MODAL';
export const SET_TERMS_ACCEPTED = 'SET_TERMS_ACCEPTED';
